import { Box, Layout, SideBarToogle, DropDown, Grid, Text, Avatar } from '@flexisaf/flexibull2';
import { Fragment, useEffect, useMemo } from 'react';
import Logo from 'assets/safsims.svg';
import { Theme } from 'config/theme';
import { Outlet } from 'react-router-dom';

import logo from '../assets/img/logo.png';
import styled, { css } from 'styled-components';

import { ProfileMenu } from './menu';
import localforage from 'localforage';
import { USER } from 'utils/constants';
import useAuthentication from 'general-hooks/useAuthentication';
import useSchoolGroup from './emis-dashboard/hooks/useSchoolGroup';
import useGroupURL from 'general-hooks/useGroupURL';

export const ListItem = styled.li`
  margin: 0 0 15px -20px;
  list-style-type: none;
  position: relative;
  font-size: ${(props) => (props.fontSize ? props.fontSize : '12px')};
  &::before {
    ${(props) =>
      props.status === 'pending' &&
      css`
        content: '';
        /* position: absolute; */
        display: inline-block;
        margin: -5px 10px -5px 0;
        width: ${(props) => (props.indicatorSize ? props.indicatorSize : '15px')};
        height: ${(props) => (props.indicatorSize ? props.indicatorSize : '15px')};
        border: 2px solid ${Theme.PrimaryBorderColor};
        border-radius: 3px;
      `}

    ${(props) =>
      props.status === 'done' &&
      css`
        /* content: '✓'; */
        content: '✓';
        /* position: absolute; */
        display: inline-block;
        margin: -5px 10px -5px 0;
        font-size: 16px;
        color: ${Theme.PrimaryGreen};
      `};

    ${(props) =>
      props.status === 'current' &&
      css`
        content: '◉';
        /* position: absolute; */
        border-radius: 100%;
        display: inline-block;
        margin: -5px 10px -5px 0;
        font-size: 16px;
        color: ${Theme.PrimaryColor};
        /* width: ${(props) => (props.indicatorSize ? props.indicatorSize : '15px')};
                  height: ${(props) => (props.indicatorSize ? props.indicatorSize : '15px')};
                  border: 1px solid ${Theme.PrimaryColor}; */
      `}
  }
`;

const TopNavBar = () => {
  const { groupURL } = useGroupURL();

  const { logOut, profile } = useAuthentication();

  const { loading, fetchGroupInfo, schoolGroupInfo } = useSchoolGroup();

  useEffect(() => {
    if (groupURL) {
      fetchGroupInfo({ schoolGroupId: groupURL, sessionId: '2024-2025' });
    }
  }, [fetchGroupInfo, groupURL]);

  return (
    <Box style={{ borderBottom: `0.5px solid ${Theme.PrimaryBorderColor}` }}>
      <Grid default="max-content auto" md="max-content auto" sm="max-content auto">
        <Box display="flex" pad="15px 30px" gap="10px">
          {schoolGroupInfo?.logo ? (
            <img
              src={schoolGroupInfo?.logo}
              height="30px"
              alt="logo"
              style={{ marginRight: '10px' }}
            />
          ) : null}
          <Text bold size="20px" style={{ margin: 'auto 0' }}>
            {schoolGroupInfo?.group_name ?? ''}
          </Text>
        </Box>
        <Box margin="0 20px 0 0" align="right" display="flex">
          <Box
            display="flex"
            style={{ alignItems: 'center', cursor: 'pointer', margin: 'auto 30px auto auto' }}
          >
            <DropDown
              style={{ zIndex: 10, textAlign: 'left' }}
              label={
                <Box pad="0 10px" display="flex" style={{ alignItems: 'center' }}>
                  <Box margin="0 -10px 0 0" display="flex" gap="5px">
                    <Avatar
                      src={''}
                      name={`user name`}
                      margin="0 10px"
                      size="30px"
                      status="online"
                      round
                    />
                    <span>
                      <Text block>
                        {profile?.first_name} {profile?.last_name}
                      </Text>
                      <Text>{profile?.username}</Text>
                    </span>
                  </Box>
                </Box>
              }
              menuAlign="bottom right"
              trigger="click"
              width="150px"
            >
              <>
                {ProfileMenu?.map((item, index) => {
                  return (
                    <li key={item.key}>
                      <Text block color={item.color} style={{ padding: '3px 0' }}>
                        <i className={item.icon} style={{ marginRight: '10px' }} />
                        {item.label}
                      </Text>
                    </li>
                  );
                })}
                <li key="log_out" onClick={() => logOut()}>
                  <Text block color={Theme.PrimaryRed} style={{ padding: '3px 0' }}>
                    <i className="saf-logout" style={{ marginRight: '10px' }} />
                    Log Out
                  </Text>
                </li>
              </>
            </DropDown>
          </Box>
        </Box>
      </Grid>
    </Box>
  );
};

function AdminLayout() {
  return (
    <>
      <Box style={{ background: '#fff' }}>
        <TopNavBar />
        <Box>
          <Outlet />
        </Box>
      </Box>
    </>
  );
}

export default AdminLayout;
